import EventEmitter from 'events'
import store from '@/stores/store'
import { ModuleContext } from '@/stores/moduleConst'
import commonFn from '@/commons/commonFunction'

class AuthService extends EventEmitter {
  /**
   * Kiểm tra xem còn session đăng nhập ko
   */
  isAuthenticated () {
    const context = store.state[ModuleContext]

    if (context.Token) {
      const expired = context.TokenExpired
      if (expired && expired > new Date()) {
        return true
      }
    }
    return false
  }

  /**
   * xử lý login qua misaid
   * hàm này sẽ build link ra redirect qua trang misaid để login
   */
  login (callbackUrl) {
    commonFn.mask()
    let loginUrl = window.__env.loginUrl

    if (callbackUrl) {
      loginUrl += `?callbackUrl=${encodeURI(callbackUrl)}`
    }

    location.href = loginUrl
  }
}

export default new AuthService()
